import {connect} from "react-redux";
import UCDLeadActivitySave from "./Save";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../../service/fileUpload/action";
import {
    markAttendancesDealerLead,
    getActivityDealerLead,
    userCheckoutDealerLead,
    activityTypes,
    newActivityDealerLead,
} from "../../../../../../service/Dealer/action";
import {getLeadById} from "../../../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    markAttendanceDetails: state.Dealer.markAttendance,
    getActivityDetails: state.Dealer.getActivity,
    isCheckoutDetails: state.Dealer.isCheckoutDetails,
    activityTypesDetails: state.Dealer.activityTypesDetails,
    NewActivityDetails: state.Dealer.saveNewActivity,
    leadById:state.Lead.leadById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            markAttendancesDealerLead,
            getActivityDealerLead,
            newActivityDealerLead,
            userCheckoutDealerLead,
            activityTypes,
            getLeadById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UCDLeadActivitySave);
